export default "__VITE_ASSET__HXIImu8r__"